import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { KioskIdleComponent } from "./kiosk-idle/kiosk-idle.component";
import { KioskInitComponent } from "./kiosk-init/kiosk-init.component";
import { KioskMenuCategoriesComponent } from "./kiosk-menu/kiosk-menu-categories/kiosk-menu-categories.component";
import { KioskMenuItemSelectedComponent } from "./kiosk-menu/kiosk-menu-items/kiosk-menu-item-selected/kiosk-menu-item-selected.component";
import { KioskMenuItemsComponent } from "./kiosk-menu/kiosk-menu-items/kiosk-menu-items.component";
import { KioskMenuComponent } from "./kiosk-menu/kiosk-menu.component";
import { KioskCheckoutComponent } from "./kiosk-order/kiosk-checkout/kiosk-checkout.component";
import { KioskOrderIdentifierComponent } from "./kiosk-order/kiosk-checkout/kiosk-order-identifier/kiosk-order-identifier.component";
import { KioskOrderTypeSelectComponent } from "./kiosk-order/kiosk-checkout/kiosk-order-type-select/kiosk-order-type-select.component";
import { KioskPaymentRequestComponent } from "./kiosk-order/kiosk-checkout/kiosk-payment-request/kiosk-payment-request.component";
import { KioskPromoCodeSelectComponent } from "./kiosk-order/kiosk-checkout/kiosk-promo-code-select/kiosk-promo-code-select.component";
import { KioskOrderActiveComponent } from "./kiosk-order/kiosk-order-active/kiosk-order-active.component";
import { KioskOrderStatusDisplayComponent } from "./kiosk-order/kiosk-order-status-display/kiosk-order-status-display.component";
import { KioskOrderComponent } from "./kiosk-order/kiosk-order.component";
import { KioskRoutingModule } from "./kiosk-routing.module";
import { KioskLicenseComponent } from './kiosk-license/kiosk-license.component';
import { KioskSubmitOrderComponent } from './kiosk-order/kiosk-checkout/kiosk-submit-order/kiosk-submit-order.component';

@NgModule({
	declarations: [
		KioskIdleComponent,
		KioskInitComponent,
		KioskMenuComponent,
		KioskMenuCategoriesComponent,
		KioskMenuItemsComponent,
		KioskOrderComponent,
		KioskOrderStatusDisplayComponent,
		KioskMenuItemSelectedComponent,
		KioskOrderActiveComponent,
		KioskCheckoutComponent,
		KioskOrderTypeSelectComponent,
		KioskPromoCodeSelectComponent,
		KioskOrderIdentifierComponent,
		KioskPaymentRequestComponent,
  KioskLicenseComponent,
  KioskSubmitOrderComponent,
	],
	imports: [SharedModule, KioskRoutingModule],
})
export class KioskModule {}
